import { useState } from "react"
import Link from "next/link"
import cn from "classnames"
import CaseWin from "components/WinsAndReviewCard/CaseWin"
import Arrow from "public/assets/down-arrow-blue-background.svg"

export default function WinsAndReviews({ name, caseWins, className }) {
  const lastIndex = caseWins?.length - 1
  const [currentSlide, setSlide] = useState(0)

  return caseWins?.length ? (
    <div
      data-pagefind-ignore="all"
      className={`wins-and-reviews overflow-hidden max-w-full sm:max-w-md xl:max-w-[300px] px-5 xl:px-3 py-8 mx-auto ${className}`}
    >
      <div className="relative w-full">
        <h3 className="font-primary text-m1 font-semibold pb-5 text-center">Latest {name} Results and Reviews</h3>

        <div className="max-w-full mx-auto pt-4">
          <div
            className="flex transition-all duration-700 gap-0 w-full"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            aria-live="off"
          >
            {caseWins.map((item, idx) => {
              const visible = idx === currentSlide
              return (
                <div
                  className={cn("min-w-full", {
                    "opacity-1": visible,
                    "opacity-0": !visible,
                  })}
                  key={idx}
                >
                  <CaseWin {...item} practice_area={{ name }} />
                </div>
              )
            })}
          </div>
        </div>

        {caseWins?.length > 1 ? (
          <>
            <button
              onClick={() => {
                setSlide(currentSlide === 0 ? lastIndex : currentSlide - 1)
              }}
              className="absolute left-0 bottom-0"
              aria-label="Previous Slide"
            >
              <Arrow className="w-10 rotate-90" />
            </button>
            <button
              onClick={() => {
                setSlide(currentSlide === lastIndex ? 0 : currentSlide + 1)
              }}
              className="absolute right-0 bottom-0"
              aria-label="Next Slide"
            >
              <Arrow className="w-10 -rotate-90" />
            </button>
          </>
        ) : null}
      </div>
      <Link
        href="/wins-and-reviews"
        className="underline decoration-secondary hover:decoration-tertiary decoration-2 underline-offset-8 pt-4 relative mx-auto table"
      >
        See All
      </Link>
    </div>
  ) : null
}
